import Axios from "axios";
import { IFloorPayload } from "../../../components/FacilityManager/Domain/Types/FloorPlan/FloorPayload.type";
import { DateTime } from "luxon";

const toIsoDate = (
  dateValue: string | null,
  fallbackDateTimeValue: string | null
): string | undefined => {
  const parsedDate = DateTime.fromISO((dateValue ?? "").trim());
  if (parsedDate.isValid) {
    return parsedDate.toISODate();
  }

  const parsedFallbackDateTime = DateTime.fromISO((fallbackDateTimeValue ?? "").trim());
  if (parsedFallbackDateTime.isValid) {
    return parsedFallbackDateTime.toISODate();
  }

  return undefined;
};

/** Resolves API `start` / `end` query params (YYYY-MM-DD). Returns null if either side is missing or invalid. */
export function getPlanDateRangeOrNull(
  bookingFrom: string | null,
  bookingStart: string | null,
  bookingTo: string | null,
  bookingEnd: string | null
): { end: string; start: string } | null {
  const start = toIsoDate(bookingFrom, bookingStart);
  const end = toIsoDate(bookingTo, bookingEnd);
  if (!start || !end) {
    return null;
  }
  return { start, end };
}

/** True when both strings parse to valid dates (used for `/plan/.../services` guards). */
export function isValidPlanDateRangeStrings(
  start: string | null | undefined,
  end: string | null | undefined
): boolean {
  const s = (start ?? "").trim();
  const e = (end ?? "").trim();
  if (!s || !e) {
    return false;
  }
  return DateTime.fromISO(s).isValid && DateTime.fromISO(e).isValid;
}

export const fetchPlan = async (
  floorInventoryId: number,
  bookingFrom: string | null,
  bookingStart: string | null,
  bookingEnd: string | null,
  bookingTo: string | null
): Promise<IFloorPayload | undefined> => {
  const range = getPlanDateRangeOrNull(bookingFrom, bookingStart, bookingTo, bookingEnd);
  if (!range) {
    return undefined;
  }

  const res = await Axios.get<IFloorPayload>(`/plan/${floorInventoryId}`, {
    params: {
      end: range.end,
      start: range.start
    }
  });

  return res.data;
};
